var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-with-btns",style:({ 'background-image': 'url(' + _vm.heroUrl + ')'})},[_c('div',{staticClass:"call-to-action"},[_c('div',{staticStyle:{"height":"6px"}}),_c('button-ring')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }